// Client-Zugriff auf die Content-Engine des Servers (mit stillen Fallbacks offline).
import type { Question } from '../../shared/types.ts';

export interface ThemeRoundResult {
  topic: string;
  title: string;
  intro: string;
  questions: (Question & { aiGenerated?: boolean })[];
  matched: number;
  generated: number;
}

export async function orderThemeRound(topic: string, count = 8, exclude: string[] = []): Promise<ThemeRoundResult> {
  const r = await fetch('/api/theme-round', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ topic, count, exclude }),
  });
  if (!r.ok) throw new Error('Themenrunde nicht verfügbar');
  return r.json();
}

let queue: { qid: string; right: boolean }[] = [];
let timer = 0;
/** Antwortquoten für die Kalibrierung melden (gesammelt) */
export function recordAnswer(qid: string, right: boolean) {
  queue.push({ qid, right });
  clearTimeout(timer);
  timer = window.setTimeout(flush, 1500);
}
function flush() {
  const answers = queue;
  queue = [];
  if (!answers.length) return;
  fetch('/api/answers', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ answers }), keepalive: true }).catch(() => {});
}
window.addEventListener('pagehide', flush);

export async function reportQuestion(qid: string, reason: string): Promise<boolean> {
  try {
    const r = await fetch('/api/report', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ qid, reason }) });
    return r.ok;
  } catch {
    return false;
  }
}

export async function fetchDaily(): Promise<{ date: string; questions: Question[] }> {
  const r = await fetch('/api/daily');
  if (!r.ok) throw new Error('Tagesrätsel nicht verfügbar');
  return r.json();
}
